export default "__VITE_ASSET__CA$TCLWo__"